import { render } from "./VetList.vue?vue&type=template&id=0fb372d4&scoped=true"
import script from "./VetList.vue?vue&type=script&lang=js"
export * from "./VetList.vue?vue&type=script&lang=js"

import "./VetList.vue?vue&type=style&index=0&id=0fb372d4&lang=css&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb372d4"]])

export default __exports__